
import { Modal, Tooltip } from "antd";
import AIfilter from "components/Filters/AIfilter";
import AIFiltersPopUp from "components/Filters/AIFiltersPopUp";
import AISearchAndSet from "components/Filters/AISearchAndSet";
import React, { useEffect, useState } from "react";
import helpicon from "../../../images/helpicon.svg";
import AIFilterModalHeader from "./AIFilterModalHeader";
import { useAppSelector } from "hooks/reduxHooks";
import { createStyles } from "antd-style";
import FiltersSidebar from "components/Filters/FilterSideBar";
import { filtersSidebarData } from "utils/Data";
import SectionTitleAndDescription from "components/Filters/SectionTitleAndDescription";


interface AIFiltersPopupNewProps {
    open: boolean;
    isFilterQuery?: boolean;
    isSearchButton?: boolean;
    handleOk?: () => void;
    handleCloseModal: () => void;
    handleSearchInitiate?: () => void;
}


const useStyle = createStyles(({ token }) => ({
    'my-modal-body': {
        background: token.blue1,
        padding: token.paddingSM,
    },
    'my-modal-mask': {
        boxShadow: `inset 0 0 15px #fff`,
    },
    'my-modal-header': {
        borderBottom: `1px dotted ${token.colorPrimary}`,
    },
    'my-modal-footer': {
        color: token.colorPrimary,
    },
    'my-modal-content': {
        padding: `0 !important`,
        borderRadius: `12px !important`,
    },
}));

const AIFiltersPopupNew: React.FC<AIFiltersPopupNewProps> = ({
    open,
    handleCloseModal,
    handleSearchInitiate,
    isFilterQuery,
    isSearchButton
}) => {
    const [isSearching, setIsSearching] = useState(false);
    const handleOk = () => {
        handleCloseModal && handleCloseModal();
        handleSearchInitiate && handleSearchInitiate();
    };
    const handleSearchLoading = (value: boolean) => {
        setIsSearching(value);
    };

    const [activeTab, setActiveTab] = useState("Filters");
    const [openDrawer, setOpenDrawer] = useState(false);
    const [key, setKey] = useState(0);

    const { styles } = useStyle();


    const toggleDrawer = () => {
        setOpenDrawer(!openDrawer);
    };

    const classNames = {
        content: styles['my-modal-content'],
    };


    // Change key when modal opens to force re-render
    useEffect(() => {
        if (open) {
            setKey((prevKey) => prevKey + 1);
        }
    }, [open]);

    return (
        <Modal
            open={open}
            onCancel={() => !isSearching && handleCloseModal()}
            style={{ top: 20, padding: 0 }}
            width={950}
            // footer={null}
            wrapClassName="p-0"
            rootClassName="p-0"
            footer={
                <div className="py-3" >
                    {/* <SearchInitiatorFilter setIsSearchLoading={handleSearchLoading} /> */}
                </div>
            }
            classNames={classNames}
        >
            <AIFilterModalHeader
                setIsSearchLoading={handleSearchLoading}
                showDrawer={toggleDrawer}
                runFrom="Chatbot"
                isModal={true}
                handleCloseModal={handleCloseModal}
                isSearchButton={isSearchButton}
            />
            <div
                style={{
                    maxHeight: "75vh",
                    padding: "24px",
                    paddingTop: 0,
                    // pointerEvents: open ? "none" : "auto",
                }}
                className="relative flex"
            >
                {open && (
                    <>
                        <div className={`transition-all ${openDrawer ? "w-[250px]" : "w-0 overflow-hidden"}`}>

                            <FiltersSidebar
                                activeTab={activeTab}
                                data={filtersSidebarData}
                                setActiveTab={setActiveTab}
                            ></FiltersSidebar>
                        </div>
                        <div className={`h-[75vh] w-full overflow-y-auto`}>

                            <div className="py-6 px-5 xl:px-8 border-b border-dashed border-main-border flex gap-5 xl:gap-12">
                                <div className="w-1/4">
                                <SectionTitleAndDescription
                                            title="Boolean Extractor"
                                            isRequiredSection={true}
                                            isHelpInfoReq={false}
                                            description="Define your ideal candidate profile, then construct a boolean search string to match it. Your boolean string can be used to source on other platforms."
                                        />
                                </div>
                                <div className="w-3/4">
                                    <AISearchAndSet />
                                </div>

                            </div>
                            <AIfilter
                                isSearchResult={true}
                                setIsSearchLoading={handleSearchLoading}
                                isFilterQuery={isFilterQuery}
                                runFrom="Chatbot"
                                isModal={true}
                            />
                        </div>
                    </>
                )}
            </div>
        </Modal>
    );
};

export default AIFiltersPopupNew;
